import * as routerNames from '@/services/router/router.names'

import ProjectsNew from '@/screens/project-new/project-new.vue'
import ProjectListing from '@/screens/project-home/project-listing.vue'
import ProjectKanban from '@/screens/project-home/project-kanban.vue'
import ProjectSchedule from '@/screens/project-schedule/project-schedule.vue'
import TaskCreate from '@/screens/task-create/task-create.vue'
import TaskDetail from '@/screens/task-detail/task-detail.vue'
import AllTasks from '@/screens/all-tasks/all-tasks.vue'
import GlobalTaskCreate from '@/screens/global-task-create/global-task-create.vue'

import ProjectSettingsAssignPeople from '@/screens/project-settings/project-settings-assign-people.vue'
import ProjectSettingsAssignGuests from '@/screens/project-settings/project-settings-assign-guests.vue'
import ProjectSettingsChecklistTemplates from '@/screens/project-settings/project-settings-checklist-templates.vue'
import ProjectSettingsCustomFields from '@/screens/project-settings/project-settings-custom-fields.vue'
import ProjectSettingsDescriptionTemplates from '@/screens/project-settings/project-settings-description-templates.vue'
import ProjectSettingsEmailSettings from '@/screens/project-settings/project-settings-email-settings.vue'
import ProjectSettingsGeneralSettings from '@/screens/project-settings/project-settings-general-settings.vue'
import ProjectSettingsManageWorkflow from '@/screens/project-settings/project-settings-manage-workflow.vue'
import ProjectSettingsWorkflowAutomations from '@/screens/project-settings/project-settings-workflow-automations.vue'
import ProjectSettingsIntegrations from '@/screens/project-settings/project-settings-integrations.vue'

export default [
  {
    path: '/:accountId/all',
    name: routerNames.ALL,
    component: AllTasks,
  },
  {
    path: '/:accountId/all-tasks',
    name: routerNames.ALL_TASKS,
    component: AllTasks,
  },
  {
    path: '/:accountId/project/new',
    name: routerNames.PROJECT_NEW,
    component: ProjectsNew,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/project/:id',
    name: routerNames.PROJECT_LISTING,
    component: ProjectListing,
  },
  {
    path: '/:accountId/project/:id/kanban',
    name: routerNames.PROJECT_KANBAN,
    component: ProjectKanban,
  },
  {
    path: '/:accountId/project-schedule/:id',
    name: routerNames.PROJECT_SCHEDULE,
    component: ProjectSchedule,
  },
  {
    path: '/:accountId/project/sample/:id',
    name: routerNames.SAMPLE_PROJECT_LISTING,
    component: ProjectListing,
  },
  {
    path: '/:accountId/project/sample/:id/kanban',
    name: routerNames.SAMPLE_PROJECT_KANBAN,
    component: ProjectKanban,
  },
  {
    path: '/:accountId/project/:id/task/new',
    name: routerNames.TASK_NEW,
    component: TaskCreate,
  },
  {
    path: '/:accountId/project/sample/:id/task/new',
    name: routerNames.SAMPLE_TASK_NEW,
    component: TaskCreate,
  },
  {
    path: '/:accountId/task/new',
    name: routerNames.GLOBAL_TASK_NEW,
    component: GlobalTaskCreate,
  },
  {
    path: '/:accountId/project/:id/task/:childId',
    name: routerNames.TASK_DETAIL,
    component: TaskDetail,
  },
  {
    path: '/:accountId/project/sample/:id/task/:childId',
    name: routerNames.SAMPLE_TASK_DETAIL,
    component: TaskDetail,
  },
  {
    path: '/:accountId/project/:id/settings/assign-people',
    name: routerNames.PROJECT_SETTINGS_ASSIGN_PEOPLE,
    component: ProjectSettingsAssignPeople,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/project/:id/settings/assign-external',
    name: routerNames.PROJECT_SETTINGS_ASSIGN_GUESTS,
    component: ProjectSettingsAssignGuests,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/project/:id/settings/checklist-templates',
    name: routerNames.PROJECT_SETTINGS_CHECKLIST_TEMPLATES,
    component: ProjectSettingsChecklistTemplates,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/project/:id/settings/custom-fields',
    name: routerNames.PROJECT_SETTINGS_CUSTOM_FIELDS,
    component: ProjectSettingsCustomFields,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/project/:id/settings/description-templates',
    name: routerNames.PROJECT_SETTINGS_DESCRIPTION_TEMPLATES,
    component: ProjectSettingsDescriptionTemplates,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/project/:id/settings/email-settings',
    name: routerNames.PROJECT_SETTINGS_EMAIL_SETTINGS,
    component: ProjectSettingsEmailSettings,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/project/:id/settings/general-settings',
    name: routerNames.PROJECT_SETTINGS_GENERAL_SETTINGS,
    component: ProjectSettingsGeneralSettings,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/project/:id/settings/manage-workflow',
    name: routerNames.PROJECT_SETTINGS_MANAGE_WORKFLOW,
    component: ProjectSettingsManageWorkflow,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/project/:id/settings/workflow-automations',
    name: routerNames.PROJECT_SETTINGS_WORKFLOW_AUTOMATIONS,
    component: ProjectSettingsWorkflowAutomations,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/project/:id/settings/integrations',
    name: routerNames.PROJECT_SETTINGS_INTEGRATIONS,
    component: ProjectSettingsIntegrations,
    meta: {
      adminOwnerOnly: true,
    },
  },
]
